<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cabinet Features</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (drainPanSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Drain Pan:</label>
            <select class="halfWidthInputField" #drainPanInput
              [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
              (change)="selectionChanged(drainPanSelection, drainPanInput.value)"
              [value]="drainPanSelection.Value.toString()">
              @for (allowable of drainPanSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (outsideAirWallBoxSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirWallBoxSelection.Name)"
            for="outsideAirWallBoxInput" class="halfWidthInputLabel">Outside Air Box:</label>
            <input type="checkbox" class="checkboxInput" id="outsideAirWallBoxInput"
              #outsideAirWallBoxInput [checked]="'true' === outsideAirWallBoxSelection.Value"
              (change)="selectionChanged(outsideAirWallBoxSelection, outsideAirWallBoxInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (pipingControlsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Piping/Controls:</label>
            <select class="halfWidthInputField" #pipingControlsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(pipingControlsSelection.Name)"
              (change)="selectionChanged(pipingControlsSelection, pipingControlsInput.value)"
              [value]="pipingControlsSelection.Value.toString()">
              @for (allowable of pipingControlsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="pipingControlsSelection.Value && pipingControlsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (insulatedRearExtensionSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(insulatedRearExtensionSelection.Name)"
            for="insulatedRearExtension" class="halfWidthInputLabel">Insulated Rear Extension:</label>
            <input type="checkbox" class="checkboxInput" id="insulatedRearExtension"
              #insulatedRearExtension [checked]="'true' === insulatedRearExtensionSelection.Value"
              (change)="selectionChanged(insulatedRearExtensionSelection, insulatedRearExtension.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (cabinetInsulationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Cabinet Insulation:</label>
            <select class="halfWidthInputField" #cabinetInsulationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
              (change)="selectionChanged(cabinetInsulationSelection, cabinetInsulationInput.value)"
              [value]="cabinetInsulationSelection.Value.toString()">
              @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (tamperProofPanelSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(tamperProofPanelSelection.Name)"
            for="tamperProofPanelInput" class="halfWidthInputLabel">Tamper Proof Panel:</label>
            <input type="checkbox" class="checkboxInput" id="tamperProofPanelInput"
              #tamperProofPanelInput [checked]="'true' === tamperProofPanelSelection.Value"
              (change)="selectionChanged(tamperProofPanelSelection, tamperProofPanelInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (cabinetMaterialSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Cabinet Material:</label>
            <select class="halfWidthInputField" #cabinetMaterialInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetMaterialSelection.Name)"
              (change)="selectionChanged(cabinetMaterialSelection, cabinetMaterialInput.value)"
              [value]="cabinetMaterialSelection.Value.toString()">
              @for (allowable of cabinetMaterialSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetMaterialSelection.Value && cabinetMaterialSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (trimKitSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(trimKitSelection.Name)"
            for="trimKitInput" class="halfWidthInputLabel">Trim Kit:</label>
            <input type="checkbox" class="checkboxInput" id="trimKitInput"
              #trimKitInput [checked]="'true' === trimKitSelection.Value"
              (change)="selectionChanged(trimKitSelection, trimKitInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (frontPanelInsulationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Front Panel Insulation:</label>
            <select class="halfWidthInputField" #frontPanelInput
              [class.invalidConfigurationSelection]="isInvalidSelection(frontPanelInsulationSelection.Name)"
              (change)="selectionChanged(frontPanelInsulationSelection, frontPanelInput.value)"
              [value]="frontPanelInsulationSelection.Value.toString()">
              @for (allowable of frontPanelInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="frontPanelInsulationSelection.Value && frontPanelInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (levelingLegsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Leveling Legs:</label>
            <select class="halfWidthInputField" #levelingLegsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(levelingLegsSelection.Name)"
              (change)="selectionChanged(levelingLegsSelection, levelingLegsInput.value)"
              [value]="levelingLegsSelection.Value.toString()">
              @for (allowable of levelingLegsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="levelingLegsSelection.Value && levelingLegsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (rightExtensionSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Right Extension (in):</label>
            <select class="halfWidthInputField" #rightExtensionInput
              [class.invalidConfigurationSelection]="isInvalidSelection(rightExtensionSelection.Name)"
              (change)="selectionChanged(rightExtensionSelection, rightExtensionInput.value)"
              [value]="rightExtensionSelection.Value.toString()">
              @for (allowable of rightExtensionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="rightExtensionSelection.Value && rightExtensionSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (leftExtensionSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Left Extension (in):</label>
            <select class="halfWidthInputField" #leftExtensionInput
              [class.invalidConfigurationSelection]="isInvalidSelection(leftExtensionSelection.Name)"
              (change)="selectionChanged(leftExtensionSelection, leftExtensionInput.value)"
              [value]="leftExtensionSelection.Value.toString()">
              @for (allowable of leftExtensionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="leftExtensionSelection.Value && leftExtensionSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (extensionHeightSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Extension Height (in):</label>
            <select class="halfWidthInputField" #extensionHeightInput
              [class.invalidConfigurationSelection]="isInvalidSelection(extensionHeightSelection.Name)"
              (change)="selectionChanged(extensionHeightSelection, extensionHeightInput.value)"
              [value]="extensionHeightSelection.Value.toString()">
              @for (allowable of extensionHeightSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="extensionHeightSelection.Value && extensionHeightSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (extensionDepthSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Extension Depth (in):</label>
            <select class="halfWidthInputField" #extensionDepthInput
              [class.invalidConfigurationSelection]="isInvalidSelection(extensionDepthSelection.Name)"
              (change)="selectionChanged(extensionDepthSelection, extensionDepthInput.value)"
              [value]="extensionDepthSelection.Value.toString()">
              @for (allowable of extensionDepthSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="extensionDepthSelection.Value && extensionDepthSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
